<template>
<div>
    <h3>Building Recon Site Selection</h3>
    <div class="wrapper">
        <div  class="row row-wider">
            <div class="col-md-12">
                <projectHeader v-bind:project="project"></projectHeader>
                <surveyHeader v-bind:survey="survey"></surveyHeader>
                <div class="form-group row">
                    <button class="btn btn-default col-md-2 col-md-offset-8" v-on:click="selectAll()">Select All</button>
                    <div class="col-md-2">
                        <select class="form-control pull-right" v-model="selectedRecordingTypeId">
                            <option value="">Select a value</option>
                            <option v-for="recordingType in recordingTypeList" v-bind:value="recordingType.id">
                                {{ recordingType.description}}
                            </option>
                        </select>
                    </div>
                </div>
                <loader v-if="isLoading" />
                <v-client-table :data="siteListGridSpec.tableData" :columns="siteListGridSpec.columns" :options="siteListGridSpec.options" ref="siteGrid">
                    <template slot="select" slot-scope="props">
                        <div style="text-align: center">
                            <input type="checkbox" v-model="selectedRecordingList" v-bind:id="props.row.buildingReconFormId" v-bind:value="props.row.buildingReconFormId" ></input>
                        </div>
                    </template>
                    <template slot="recordingType" slot-scope="props">
                        <div>
                            <select class="form-control" v-model="props.row.recordingTypeId" v-on:change="markChanged(props.row.buildingReconFormId, $event)">
                                <option value="">Select a value</option>
                                <option v-for="recordingType in recordingTypeList" v-bind:value="recordingType.id">
                                    {{ recordingType.description}}
                                </option>
                            </select>
                        </div>
                    </template>
                </v-client-table>
            </div>
        </div>
        <div>
            <button class="btn btn-primary" v-on:click="save">Save</button>
        </div>
    </div>
</div>
</template>

<script>
import buildingReconFormService from '@/services/buildingReconFormService'
import buildingSurveyService from '@/services/buildingSurveyService'
import projectService from '@/services/projectService'
import loggingService from '@/services/util/loggingService'
import lookupService from '@/services/lookup/lookupService'
import culturalResourceRecordingService from '@/services/culturalResourceRecordingService'

import loader from '@/components/Loader'
import projectHeader from '@/components/ProjectHeader'
import surveyHeader from '@/components/SurveyHeader'

export default {
    name: 'BuildingReconSiteSelection',
    components: {
        loader,
        projectHeader,
        surveyHeader
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            siteListGridSpec: {
                columns: ['select', 'smithsonianNumber', 'historicName', 'recordingType'],
                tableData: [],
                options: {
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        select: '',
                        edit: 'View/Edit',
                        smithsonianNumber: 'Smithsonian Number',
                        historicName: 'Historic Name',
                        recordingType: 'Record Type'
                    }
                }
            },
            formChangeset: [],
            recordingTypeList: [],
            selectedRecordingList: [],
            selectedRecordingTypeId: '',
            project: {},
            survey: {}
        }
    },
    watch: {
        selectedRecordingTypeId: function (val) {
            loggingService.log(this.isDebug, 'CRSelection', 'selected recording type')
            this.selectedRecordingList.forEach(id => {
                var selectedCR = this.siteListGridSpec.tableData.find(rec => rec.buildingReconFormId === id)
                this.markChanged(id, {target: {value: val}})
                selectedCR.recordingTypeId = val
            })
        }
    },
    computed: {
        buildingSurveyId: function () {
            return this.$route.query.buildingSurveyId
        }
    },
    mounted () {
        this.loadLookups().then(result => {
            this.loadData().then(result2 => {
                this.log('Done loading')
            })
        })
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'BuildingReconSiteSelection', message)
        },
        loadLookups () {
            return lookupService.listLookup(this.$http, 'RecordingType').then(response => {
                this.recordingTypeList = response.data.filter(x => {
                    return (x.id === culturalResourceRecordingService.RecordingTypeEnum.FirstRecording ||
                        x.id === culturalResourceRecordingService.RecordingTypeEnum.FullRerecord ||
                        x.id === culturalResourceRecordingService.RecordingTypeEnum.Update ||
                        x.id === culturalResourceRecordingService.RecordingTypeEnum.OutsideAPE)
                })
                return response
            })
        },
        loadReconForms () {
            return buildingReconFormService.search(this.$http, {buildingSurveyId: this.buildingSurveyId, buildIfEmpty: true}, false).then(result => {
                this.log('Setting result data: ' + result.data.length)
                this.siteListGridSpec.tableData = result.data
            })
        },
        loadSurvey () {
            return buildingSurveyService.get(this.$http, this.buildingSurveyId).then(result => {
                this.log('Survey Loaded.: ' + result.data.buildingSurveyId)
                this.survey = result.data
                return this.loadProject()
            })
        },
        loadProject () {
            return projectService.get(this.$http, this.survey.projectId).then(result => {
                this.log('Project Loaded: ' + result.data.buildingSurveyId)
                this.project = result.data
                return result
            })
        },
        loadData () {
            this.isLoading = true
            this.log('Load data for ' + this.buildingSurveyId)
            return Promise.all([this.loadReconForms(), this.loadSurvey()]).then(result => {
                this.selectedRecordingList = []
                this.selectedRecordingTypeId = ''
                this.formChangeset = []
                this.isLoading = false
                return result
            })
        },
        markChanged (buildingReconFormId, event) {
            this.log(`recording type was selected  id: ${buildingReconFormId}, newrecordingType: ${event.target.value}`)
            if (!this.formChangeset.find(x => { x === buildingReconFormId })) {
                this.formChangeset.push(buildingReconFormId)
            }
            this.siteListGridSpec.tableData.find(x => {
                return x.buildingReconFormId === buildingReconFormId
            }).recordingTypeId = event.target.value
        },
        selectAll () {
            this.selectedRecordingList = this.siteListGridSpec.tableData.map(x => {
                return x.buildingReconFormId
            })
        },
        save () {
            this.isLoading = true
            var promises = []
            this.formChangeset.forEach(changeSetId => {
                loggingService.log(this.isDebug, 'CRSelection', 'Looking for ' + changeSetId)
                var selectedForm = this.siteListGridSpec.tableData.find(x => {
                    return x.buildingReconFormId === changeSetId
                })
                if (selectedForm) {
                    loggingService.log(this.isDebug, 'CRSelection', 'saving ' + changeSetId)
                    promises.push(buildingReconFormService.put(this.$http, selectedForm, false))
                }
            })
            Promise.all(promises).then(result => {
                this.log('Done saving')
                this.loadData()
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// buildingReconSiteSelection.vue?59b22719